"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 视频路演 东财im
 */
var roadshow_im_1 = __importDefault(require("./roadshow_im"));
var user_1 = __importDefault(require("../user"));
var moment_1 = __importDefault(require("moment"));
var thisuser = user_1.default.get();
var newtime = undefined;
/**
 * 展示时间
 * @param SendDateTime 发送时间
 * @param preSendDateTime 上一条的发送时间
 */
function getShowTime(SendDateTime, preSendDateTime) {
    var thistime = (0, moment_1.default)(SendDateTime * 1000);
    var sameBlock = false; //是否和上一条同在一个块
    if (preSendDateTime != undefined) {
        var pretime = (0, moment_1.default)(preSendDateTime * 1000);
        sameBlock = thistime.isSameOrBefore(pretime.add(5, 'minute')); //5分钟间隔不重复显示
    }
    if (sameBlock) {
        return '';
    }
    /**
     * 是否是同一天
     */
    var issameyear = (0, moment_1.default)().isSame(thistime, 'year');
    var issameday = (0, moment_1.default)().isSame(thistime, 'day');
    if (issameyear) {
        if (issameday) {
            return thistime.format("HH:mm");
        }
        else {
            return thistime.format("MM月DD日 HH:mm");
        }
    }
    else {
        return thistime.format("YYYY年MM月DD日 HH:mm");
    }
}
/**
 * 处理单条消息
 * @param message
 */
function dealOneMessage(v) {
    //处理object
    if (typeof v.Content == 'string') {
        try {
            v.Content = JSON.parse(v.Content);
        }
        catch (error) {
            v.Content = {
                txt: v.Content
            };
        }
    }
    try {
        if (v.QuoteMessage && v.QuoteMessage.Content) {
            v.QuoteMessage.Content = JSON.parse(v.QuoteMessage.Content);
        }
    }
    catch (error) {
    }
    //#region 处理type
    v.type = 'normal';
    //私信
    if (v.Content.receiver != undefined) {
        if (thisuser != null && v.Content.receiver && v.Content.receiver.emuid == thisuser.id) {
            v.type = 'private'; //我的私信
        }
        else {
            v.type = 'nomyprivate'; //不是我的私信
        }
    }
    //回复
    else if (v.QuoteMessage != undefined) {
        v.type = 'reply';
    }
    //#endregion
    //#region 处理isSelf
    v.isSelf = false;
    if (thisuser != null) {
        v.isSelf = v.Sender.UserID == thisuser.id;
    }
    //#endregion
    //#region 处理showtime
    v.showtime = getShowTime(v.SendDateTime, newtime);
    newtime = v.SendDateTime;
    //#endregion
}
exports.default = {
    dealOneMessage: dealOneMessage,
    /**
     * 获取历史聊天记录
     */
    getMessageList: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        roadshow_im_1.default.getList(function (data) {
                            if (!data) {
                                resolve([]);
                                return;
                            }
                            ;
                            //if(data.result == 1){
                            var backlist = data.map(function (v) {
                                var ContentObj = JSON.parse(v.Content);
                                return ContentObj;
                            });
                            backlist.forEach(function (v) {
                                dealOneMessage(v);
                            });
                            backlist = backlist.filter(function (v) {
                                return v.type != 'nomyprivate';
                            });
                            resolve(backlist);
                            //}
                            //else{
                            //  reject(new Error('获取聊天历史列表失败'))
                            //}
                        });
                    })];
            });
        });
    },
    /**
     *  根据条件查询历史
     * @returns
     */
    getChannelMessagesForPri: function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        roadshow_im_1.default.getHistoryListForPri(params, function (data) {
                            try {
                                if (!data) {
                                    resolve([]);
                                    return;
                                }
                                ;
                                var list = data || [];
                                var backlist = list.map(function (v) {
                                    var _a, _b;
                                    v.Content = JSON.parse(v.Content);
                                    v.sendtime = v.SendDateTime;
                                    v.SendDateTime = ((0, moment_1.default)(v.SendDateTime).valueOf().toString()).substr(0, 10);
                                    var Senderobj = {
                                        Nick: v.SenderNickName,
                                        UserID: v.Sender
                                    };
                                    v.Sender = Senderobj;
                                    if (v === null || v === void 0 ? void 0 : v.QuoteMessage) {
                                        var quotecontent = JSON.parse((_a = v === null || v === void 0 ? void 0 : v.QuoteMessage) === null || _a === void 0 ? void 0 : _a.Content);
                                        var QuoteMessage = {
                                            Sender: {
                                                Nick: (_b = v === null || v === void 0 ? void 0 : v.QuoteMessage) === null || _b === void 0 ? void 0 : _b.SenderNickName
                                            },
                                            Content: {
                                                txt: quotecontent.txt
                                            }
                                        };
                                        v.QuoteMessage = QuoteMessage;
                                    }
                                    return v;
                                });
                                backlist.forEach(function (v) {
                                    dealOneMessage(v);
                                });
                                backlist = backlist.filter(function (v) {
                                    return v.type != 'nomyprivate';
                                });
                                resolve(backlist);
                            }
                            catch (error) {
                                resolve([]);
                            }
                        });
                    })];
            });
        });
    },
    /**
     * 注册事件：有新消息来了
     * @param callback
     */
    regGetNewMessage: function (callback) {
        roadshow_im_1.default.regGetNewMessage(function (data) {
            dealOneMessage(data);
            callback(data);
        });
    },
    /**
     * 发布新消息
     * @param newmessage
     */
    sendNewMessage: function (newmessage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, roadshow_im_1.default.sendNewMessage(newmessage)];
            });
        });
    },
    sendNewQuoteMessage: function (newmessage, quotemessage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, roadshow_im_1.default.sendNewQuoteMessage(newmessage, quotemessage)];
            });
        });
    },
    /**
     * 被禁言
     * @param callback
     */
    onForbidden: function (callback) {
        roadshow_im_1.default.onForbidden(callback);
    },
    /**
     * 被解除禁言
     * @param callback
     */
    onCancelForbidden: function (callback) {
        roadshow_im_1.default.onCancelForbidden(callback);
    },
    /**
     * 全员被禁言
     * @param callback
     */
    onAllForbidden: function (callback) {
        roadshow_im_1.default.onAllForbidden(callback);
    },
    /**
     * 全员被解除禁言
     * @param callback
     */
    onAllCancelForbidden: function (callback) {
        roadshow_im_1.default.onAllCancelForbidden(callback);
    },
    regDocumentShow: function (callback) {
        roadshow_im_1.default.regDocumentShow(function (data) {
            var outdata = JSON.parse(data.Content);
            callback({
                autoplay: outdata.message.autoplay,
                current: outdata.message.current_page.page,
                id: outdata.message.id
            });
        });
    },
    regDocumentEnd: function (callback) {
        roadshow_im_1.default.regDocumentEnd(callback);
    },
    onShowStart: function (callback) {
        roadshow_im_1.default.onShowStart(callback);
    },
    /**
     * 直播结束
     * @param callback
     */
    onShowEnd: function (callback) {
        roadshow_im_1.default.onShowEnd(callback);
    },
    /**
     * 主播离开直播间
     * @param callback
     */
    onPresentersLeft: function (callback) {
        roadshow_im_1.default.onPresentersLeft(callback);
    },
    /**
     * 主播通知路演继续
     * @param callback
     */
    onPresentersContinue: function (callback) {
        roadshow_im_1.default.onPresentersContinue(callback);
    },
    /**
     * 被提出直播间
     */
    onKickOut: function (callback) {
        roadshow_im_1.default.onKickOut(callback);
    },
    onNotice: function (callback) {
        roadshow_im_1.default.onNotice(callback);
    },
    /**
     * 删除直播间
     * @param callback
     */
    onDeleteRome: function (callback) {
        roadshow_im_1.default.onDeleteRome(callback);
    },
    /**
     * 预告地址变更
     * @param callback
     */
    onChangeForeshow: function (callback) {
        roadshow_im_1.default.onChangeForeshow(callback);
    },
    /**
     * 直播地址变更
     * @param callback
     */
    onChangeLiveshow: function (callback) {
        roadshow_im_1.default.onChangeLiveshow(callback);
    },
    /**
     * 直播测试结束
     * @param callback
     */
    onShowTestEnd: function (callback) {
        roadshow_im_1.default.onShowTestEnd(callback);
    },
    /**
     * 直播测试地址变更
     * @param callback
     */
    onChangeLiveTestshow: function (callback) {
        roadshow_im_1.default.onChangeLiveTestshow(callback);
    }
};
//# sourceMappingURL=data:application/json;base64,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